export enum Belong {

  CONTACT = 'CONTACT',
  CONTACT_VEHICLE = 'CONTACT_VEHICLE',
  ARTICLE = 'ARTICLE',
  INVOICE = 'INVOICE',
  RECEIPT = 'RECEIPT',
  DEATH = 'DEATH',
  SHEET = 'SHEET',
}
